import {
  EJSON,
} from './ejson';

export default EJSON;
